"use client";

import HcpAccordion from '@/components-hcp/accordion';
import styles from './_hydrocortisone-doses.module.scss';
import CustomImage from '@/components/image';

export default function HcpClinicalInformationHydrocortisoneDoses() {
  return (
    <section className={styles.container}>
      <HcpAccordion label="View GC regimen changes">
        <div className="container">
          <div className={styles.content}>
            <div className={styles.headingWrapper}>
              <h2 className="page-heading h2">
                Some children taking CRENESSITY were able to reduce their daily number of hydrocortisone doses<sup>8</sup>
              </h2>
            </div>

            <div className={styles.grid}>
              <div />
              <div className={styles.grid_col}>
                <p className={styles.subtitle}>
                  Achieved reductions in number of daily hydrocortisone doses at week 28<sup>8</sup><span className='super-asterisc'>*</span>
                </p>

                <div className={styles.contentWrapper}>
                  <div className={styles.imageWrapper}>
                    <CustomImage
                      src="/images/page/hcp/clinical-information/Clinical-Information_Pediatric-Daily-Hydrocortisone-Doses.svg"
                      alt="16% of patients taking CRENESSITY were able to reduce their number of daily hydrocortisone doses vs 4% with placebo."
                      width={800}
                      height={400}
                    />
                  </div>

                  <p className={styles.sideNote}>
                    The most nonphysiologic dose was eliminated first (ie,&nbsp;bedtime&nbsp;dose).<sup>11</sup>
                  </p>
                </div>

                <div className={styles.purpleText}>
                  <p>
                    This prespecified exploratory endpoint was not adjusted for multiplicity; these descriptive results could represent chance findings.<sup>8</sup>
                  </p>
                </div>

                <ul className={`${styles.footnotes} clear-both footnotes`}>
                  <li>
                    <span className="hang">*</span>
                    <span>Percentages are number of patients on hydrocortisone alone at baseline with a dosing frequency of more than once per day who were able to eliminate at least 1 dosing instance per day by week 28.<sup>8</sup></span>
                  </li>
                </ul>
              </div>

              <div className={styles.sideNoteWrapper}>
                <p className={`${styles.sideNote} ${styles.sideNote_left}`}>
                  The most nonphysiologic dose was eliminated first (ie,&nbsp;bedtime&nbsp;dose).<sup>11</sup>
                </p>
              </div>
            </div>
          </div>
        </div>
      </HcpAccordion>
    </section>
  );
}